module.exports = new __parcel__URL__("epic_pack.54be55a9.png").toString();